// src/services/emailRecipientService.js
import { apiRequest } from '../api/client';
import { endpoints } from '../api/endpoints';

export function estimateRecipients(filterPayload) {
    return apiRequest(endpoints.EmailRecipientsEstimate, {
        method: 'POST',
        body: JSON.stringify(filterPayload),
    });
}

export function validateRecipients(filterPayload) {
    return apiRequest(endpoints.EmailRecipientsValidate, {
        method: 'POST',
        body: JSON.stringify(filterPayload),
    });
}

export function searchRecipients(query) {
    return apiRequest(endpoints.EmailRecipientsSearch(query), { method: 'GET' });
}

export function importRecipientsCsv(file) {
    const formData = new FormData();
    formData.append('file', file);
    const token = localStorage.getItem('accessToken');
    return apiRequest(endpoints.EmailRecipientsCsvImport, {
        method: 'POST',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        body: formData,
    });
}

export function getRecipientGroups() {
    return apiRequest(endpoints.EmailRecipientGroups, { method: 'GET' });
}

export function createRecipientGroup(group) {
    return apiRequest(endpoints.EmailRecipientGroups, {
        method: 'POST',
        body: JSON.stringify(group),
    });
}

export function deleteRecipientGroup(id) {
    return apiRequest(endpoints.EmailRecipientGroup(id), { method: 'DELETE' });
}
